import { DetailForm } from '@/@diffrag/form/DetailForm'
import { FormFieldData, FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { api } from '@/api'
import {
  AdminPointCreateData,
  IAdminPointTransactionCreateReferenceTypeEnum,
  IAdminPointTransactionCreateTypeEnum,
  IAdminPointTransactionRO,
  ReferenceTypesEnum,
  TypeEnum1,
  TypeEnum6,
} from 'api'
import { useNavigate } from 'react-router-dom'

export default function PointTransactionEdit() {
  const navigate = useNavigate()
  const id = useQueryValue('id', 0)

  const { data: pointRuleList } = useApi({
    id: 'pointRuleList',
    fn: api().adminPointRule.adminPointRuleList,
  })

  // 포인트 거래 내역은 조회만 가능하고 수정/삭제는 불가
  // id가 있으면 조회 모드 (읽기 전용), 없으면 신규 등록 모드
  const { data, refetch } = useApi({
    id: 'pointTransactionDetail',
    fn: api().adminPoint.adminPointDetail,
    params: Number(id),
    enabled: !!id,
  })

  const onSave = async (formData: AdminPointCreateData) => {
    let point = data?.amount
    console.log('formData', formData)
    if (formData.type === 'USE') {
      point = -formData.amount
    }

    if (formData.type === 'EARN') {
      point = +formData.amount
    }

    if (!point) {
      alert('포인트가 없습니다.')
      return
    }

    try {
      if (!id) {
        // 신규 등록만 가능
        await api().adminPoint.adminPointCreate({
          type: formData.type as IAdminPointTransactionCreateTypeEnum,
          amount: point,
          description: formData.description || '',
          referenceType:
            formData.referenceType as IAdminPointTransactionCreateReferenceTypeEnum,
          userId: formData.userId.id,
        })
        navigate(`/point-transaction`)
      }
    } catch (error) {
      console.error('등록 중 오류 발생:', error)
      alert('등록 중 오류가 발생했습니다.')
    }
  }

  const fields: FormFieldData<IAdminPointTransactionRO>[] = [
    {
      label: '구분',
      key: 'type',
      type: FormFieldType.SELECT,
      options: [
        { label: '적립', value: 'EARN' },
        { label: '사용/차감', value: 'USE' },
      ],
      required: true,
      readOnly: !!id,
    },
    {
      label: '포인트',
      key: 'amount',
      type: FormFieldType.NUMBER,
      required: true,
      readOnly: !!id,
    },
    {
      label: '포인트명',
      key: 'referenceType',
      type: FormFieldType.SELECT,
      options:
        pointRuleList?.rows.map((rule) => ({
          label: rule.name || rule.referenceType,
          value: rule.referenceType,
        })) || [],
      required: true,
      readOnly: !!id,
    },
    {
      label: '상세설명',
      key: 'description',
      type: FormFieldType.STRING,
      readOnly: !!id,
      placeholder: '포인트 거래에 대한 설명을 입력하세요',
    },
  ]

  if (id) {
    fields.push({
      label: '사용자',
      key: 'user.userData.name',
      type: FormFieldType.STRING,
      readOnly: true,
      required: true,
    })
  } else {
    fields.push({
      label: '사용자',
      key: 'userId',
      type: FormFieldType.RELATION,
      searchApiFn: async ({ searchText, amount, page }) => {
        const result = await api().adminUser.adminUserList({
          page: page || 1,
          pageSize: 100000,
          q: searchText || '',
          type: 'USER' as never,
        })

        // userData에 id를 추가한 객체로 매핑
        const users = result.users.map((user) => ({
          ...user.userData,
          id: user.id, // user의 id를 userData에 추가
        }))

        return {
          rows: users,
          total: result.total,
          page: page || 1,
        }
      },
      labelKey: 'nickname',
      // valueKey: '',
      required: true,
    })
  }

  return (
    <ContentDetailView
      title={id ? '포인트 거래 내역 조회' : '포인트 거래 등록'}
      data={data}
      onSave={id ? undefined : onSave} // 조회 모드에서는 저장 불가
    >
      <DetailForm data={data} fields={fields} />
    </ContentDetailView>
  )
}
